<template>
  <div class="policy-progress" :class="{ 'is-unavailable': percent == null }">
    <div v-if="percent != null" class="policy-progress-track" role="progressbar" :aria-label="label + '进度'" aria-valuemin="0" aria-valuemax="100" :aria-valuenow="Math.min(100, percent)" :aria-valuetext="text">
      <span class="policy-progress-fill" :style="{ width: Math.min(100, percent) + '%', backgroundColor: color }" />
    </div>
    <div v-else class="policy-progress-track" :aria-label="label + '：' + text" />
    <span class="policy-progress-text">{{ text }}</span>
  </div>
</template>

<script>
import { policyNumber, policyProgress } from '../services/policyProgress'

export default {
  name: 'PolicyProgressBar',
  props: { value: {}, target: {}, label: { type: String, default: '指标' }, color: { type: String, default: '#2f86d4' }, budget: Boolean },
  computed: {
    percent () { return policyProgress(this.value, this.target) },
    text () {
      const goal = policyNumber(this.target)
      if (goal == null) return this.budget ? '未设预算' : '未设目标'
      if (goal === 0) return this.budget ? '预算为0' : '目标为0'
      if (goal < 0) return this.budget ? '预算无效' : '目标无效'
      return this.percent == null ? '暂无数据' : String(Math.round(this.percent * 10) / 10) + '%'
    }
  }
}
</script>
